/* import __COLOCATED_TEMPLATE__ from './copilot-summary.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';

export default class StandaloneCopilotSummaryCard extends Component {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get copilotSeatCount() {
    return this.appService.app.humanAdminsWithCopilotSeat.length;
  }

  get title() {
    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Salesforce)) {
      return this.intl.t('standalone.channels.overview.cards.salesforce-copilot.title');
    } else if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Zendesk)) {
      return this.intl.t('standalone.channels.overview.cards.zendesk-copilot.title');
    }

    return '';
  }

  get description() {
    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Salesforce)) {
      return this.intl.t('standalone.channels.overview.cards.salesforce-copilot.live-description');
    } else if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Zendesk)) {
      return this.intl.t('standalone.channels.overview.cards.zendesk-copilot.live-description');
    }

    return '';
  }

  get manageRoute() {
    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Salesforce)) {
      return 'apps.app.standalone.deploy.salesforce.copilot';
    } else if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Zendesk)) {
      return 'apps.app.standalone.deploy.zendesk.copilot';
    }

    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Overview::CopilotSummary': typeof StandaloneCopilotSummaryCard;
    'standalone/deploy/overview/copilot-summary': typeof StandaloneCopilotSummaryCard;
  }
}
